import type { SamudkoyMenuId } from '../../types'
import { useSamudkoyStore } from '../../stores/samudkoy'
import { computed, type ComputedRef } from 'vue'
import { getPageByMenu } from '../../helpers/getPageByMenu'

interface UseMenuSamudkoy {
  currentMenu: ComputedRef<SamudkoyMenuId>
  doSelectMenu: (menu: SamudkoyMenuId) => void
  doSelectMenuFlipToAnimate: (menu: SamudkoyMenuId) => void
}

//------------------------------------------------
export function useMenuSamudkoy(): UseMenuSamudkoy {
  const samudkoyStore = useSamudkoyStore()

  const currentMenu = computed(() => samudkoyStore.menu)

  function doSelectMenu(menu: SamudkoyMenuId) {
    samudkoyStore.translateOff()
    samudkoyStore.flipTo(getPageByMenu(menu))
  }

  function doSelectMenuFlipToAnimate(menu: SamudkoyMenuId) {
    samudkoyStore.translateOff()
    samudkoyStore.flipTo(getPageByMenu(menu))
  }

  return {
    currentMenu,
    doSelectMenu,
    doSelectMenuFlipToAnimate,
  }
}

//------------------------------------------------
export function useMenuSamudkoyMock(): UseMenuSamudkoy {
  const currentMenu = computed(() => 'menu2' as SamudkoyMenuId)

  function doSelectMenu(menu: SamudkoyMenuId) {
    console.debug('doSelectMenu()', { menu })
  }

  function doSelectMenuFlipToAnimate(menu: SamudkoyMenuId) {
    console.debug('doSelectMenuFlipToAnimate()', { menu })
  }

  return {
    currentMenu,
    doSelectMenu,
    doSelectMenuFlipToAnimate,
  }
}
